import type { MouseEvent } from 'react';

/**
 * Whether a click navigates this tab rather than opening a new one. Gates the
 * side effects that should only run when this tab is actually leaving the page.
 * A cancelled click must not run them without navigating.
 */
export function isPlainLeftClick(event: MouseEvent<HTMLElement>) {
  return (
    event.button === 0 &&
    !event.defaultPrevented &&
    !event.metaKey &&
    !event.altKey &&
    !event.ctrlKey &&
    !event.shiftKey
  );
}
